// extracted by mini-css-extract-plugin
export default {"li":"LinkMenu_li__YV7kU","liActive":"LinkMenu_liActive__v8KFr"};